import React from "react"

const WidgetLogo = () => {
    return <img src={`/logo--${window._env_.THEME}.svg`} alt="Logo" style={{ width: "110px", height: "40px", objectFit: "contain" }} />
}

export default WidgetLogo